<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1VG5aF/Images/cover.jpg?1685327424425" alt="This image is the cover for the book A Day at a Time"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Day at a Time
      </h1>
      <p class="bookDescription body article font2">
        <p>Sean Vargos is quiet, well respected, and dedicated to his job. But Dave Simpson sees Sean as more than a coworker. He's fought his attraction to Sean for months but can't get him out of his thoughts.</p> <p>They tentatively embark on a relationship, but Sean isn’t all that he seems. He struggles to put his past behind him and overcome his fears.</p> <p>Dave, with his good looks and open nature, accepts that sometimes Sean’s doubts get the better of him and he runs. Dave just wants the chance to show Sean he can be trusted and the past doesn't have to dictate their future.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nic Starr
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3c33ce02